import "./App.css";
import * as styled from "./components/layout/mainContent";
import Header from "./components/layout/header/Header";
import Navbar from "./components/layout/navbar/Navbar";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./routes/PrivateRoute";
import { member_route_public, memberRouteData, privateRouteData, publicRouteData, reportRouteData } from "./routes/routes";
import Loading from "./components/loading/Loading";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import envInstants from "./configs/env";
import { setDefaultURL } from "./api/api";
import Login from "./pages/auth/login";
import moment from "moment";
import { profileAsync } from "./store/profile/profile.slice";
import MainSkeleton from "./components/sketelon/MainSkeleton";
import { routeName } from "./routes/routeName";
import FileDiploma from "./pages/cms/course-online/diploma/file-diploma";
import HeaderWebsite from "./components/header/HeaderWebsite";
import { setApi } from "./store/api/apiSlice";
import FooterWebsite from "./components/footer/FooterWebsite";
import GuestRoute from "./routes/GuestRoute";
import AOS from 'aos'
import MemberRoute from "./routes/MemberRoute";

function App() {
  moment.locale("th");
  const isLoading: boolean = useSelector(
    (state: any) => state?.loading?.isLoading
  );
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [isInitEnvError, setInitEnvError] = useState<boolean>(false);
  const [isInitEnv, setInitEnv] = useState<boolean>(false);
  useEffect(() => {
    const loadEnv = async () => {
      try {
        await envInstants.init();
        const response = await fetch("/resources/config.json");
        const results = await response.json();
        setDefaultURL(envInstants.getConfig().baseUrl);
        dispatch(setApi({
          api: envInstants.getConfig()?.baseUrl,
          image_api: results?.REACT_APP_BASE_FILE_API,
          public_content_api: results?.REACT_APP_BASE_FRONT
        }))
      } catch (error) {
        setInitEnvError(true);
      } finally {
        setInitEnv(true);
        dispatch(profileAsync());
      }
    };

    loadEnv();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);


  if (!isInitEnv) return <MainSkeleton />;
  if (isInitEnvError) return <div>"Cannot load env !!!"</div>;



  const not_show_header_and_footer: string[] = [routeName.authentication.login_member];
  if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
    const _RO = window.ResizeObserver;
    // @ts-ignore
    window.ResizeObserver = class DebugRO extends _RO {
      constructor(callback: ResizeObserverCallback) {
        const wrapped: ResizeObserverCallback = (entries, obs) => {
          // const t = entries[0]?.target as HTMLElement | undefined;
          // const id = t?.id ? `#${t.id}` : '';
          // const cls = t?.className ? `.${String(t.className).split(' ').join('.')}` : '';
          // const stack = new Error().stack?.split('\n').slice(0, 6).join('\n');
          callback(entries, obs);
        };
        // @ts-ignore
        super(wrapped);
      }
    };
  }
  return (
    <div className="App">
      <Loading loading={isLoading} />
      <Routes>
        <Route path="/login" element={
          <GuestRoute>
            <Login />
          </GuestRoute>
        }
        />

        {/* PUBLIC ROUTE  👇*/}
        {publicRouteData.map((list) => {
          return (
            <Route
              key={list.key}
              path={list.pathName}
              element={
                <>
                  {!not_show_header_and_footer.includes(list.pathName) && (
                    <HeaderWebsite />
                  )}
                  {list.elements}
                  {!not_show_header_and_footer.includes(list.pathName) && (
                    <FooterWebsite />
                  )}
                </>
              }
            ></Route>
          );
        })}

        {/* PRIVATE ROUTE  👇*/}
        <Route element={<PrivateRoute />}>
          {privateRouteData.map((list) => {
            return (
              <Route
                key={list.key}
                path={list.pathName}
                element={
                  <styled.MainContainer>
                    <Header />
                    <styled.ComponentContainer>
                      <Navbar />
                      <styled.ContentContainer id="contentContainer">
                        {list.elements}
                      </styled.ContentContainer>
                    </styled.ComponentContainer>
                  </styled.MainContainer>
                }
              ></Route>
            );
          })}
        </Route>
        {/* PRIVATE ROUTE  👇*/}
        <Route element={<PrivateRoute is_member />}>
          {member_route_public.map((list) => {
            return (
              <Route
                key={list.key}
                path={list.pathName}
                element={
                  <>
                    {!not_show_header_and_footer.includes(list.pathName) && (
                      <HeaderWebsite />
                    )}
                    {list.elements}
                    {!not_show_header_and_footer.includes(list.pathName) && (
                      <FooterWebsite />
                    )}
                  </>
                }
              ></Route>
            );
          })}
        </Route>
        <Route element={<MemberRoute />}>
          {memberRouteData.map((list) => {
            return (
              <Route
                key={list.key}
                path={list.pathName}
                element={
                  <styled.MainContainer>
                    <Header />
                    <styled.ComponentContainer>
                      <Navbar />
                      <styled.ContentContainer id="contentContainer">
                        {list.elements}
                      </styled.ContentContainer>
                    </styled.ComponentContainer>
                  </styled.MainContainer>
                }
              ></Route>
            );
          })}
        </Route>
        {/* REPORT ROUTE  👇*/}
        {reportRouteData.map((list) => {
          return (
            <Route key={list.key} path={list.pathName} element={list.elements} />
          )
        })}
        <Route path={routeName.cms.FileDiploma} element={<FileDiploma />} />
        <Route path="*" element={<h1>404</h1>} />
      </Routes>
    </div>
  );
}

export default App;
